module.exports = __webpack_public_path__ + "static/media/ManageMultiUser1.6ff1eb40.png";